import axios from 'axios';
import { API_URL } from '../config';

// Base URL for API calls
const API_BASE_URL = API_URL;
const API_V1_URL = `${API_BASE_URL}/api/v1`;

// Create a custom axios instance
const api = axios.create({
  baseURL: API_V1_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important for CORS with credentials
});

// Add request interceptor to automatically include auth token
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    // Add token to headers if available
    if (token) {
      // Add token to both header formats for compatibility
      config.headers['Authorization'] = `Bearer ${token}`;
      config.headers['x-auth-token'] = token;
    }
    
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for consistent error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Makes a direct request bypassing the api instance
 * Used as a fallback for problematic requests (especially PATCH)
 */
export const directRequest = async (method, url, data = null, token = null) => {
  // If no token provided, try to get it from localStorage
  if (!token) {
    token = localStorage.getItem('token');
  }
  
  const headers = {
    'Content-Type': 'application/json'
  };
  
  // Add auth headers if token is available
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
    headers['x-auth-token'] = token;
  }
  
  try {
    const response = await axios({
      method,
      url: `${API_V1_URL}${url}`,
      data,
      headers,
      withCredentials: true
    });
    
    return response;
  } catch (error) {
    console.error('Direct Request Error:', {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      url,
      method
    });
    
    throw error;
  }
};

export default api;
